import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from '../components/ActionButton';
import { ActionButtonProps } from '../components/ActionButton';
import { BrandingData, StoreState } from '../types';
import { getBranding } from '../reducers';

/**
 * A convenience wrapper around the design system button component that specifies
 * the large size, sets the shadow property, and disables the button if it is loading.
 * We further extend the button to provide for a common branding experience if
 * we have branding data.
 */
export default connect(mapStateToProps)(
  class ActionButtonContainer extends React.Component<
    ActionButtonContainerProps
  > {
    constructor(props: ActionButtonContainerProps) {
      super(props);
    }

    render() {
      const { branding, ...props } = this.props;

      // the button's color should be the actionColor if we
      // have branding data
      return (
        <ActionButton
          backgroundColor={branding && branding.actionColor}
          {...props}
        />
      );
    }
  }
);

/**
 * Extend the component's properties to add branding data
 */
export interface ActionButtonContainerProps extends ActionButtonProps {
  branding?: BrandingData;
}

function mapStateToProps(
  state: StoreState,
  _ownProps?: ActionButtonProps
): Pick<ActionButtonContainerProps, 'branding'> {
  return {
    branding: getBranding(state)
  };
}



// WEBPACK FOOTER //
// ./src/containers/ActionButton.tsx